<template>
  <div class="pos-mobile-number">
    <div>
      <div class="row">
        <div class="col-12 mx-auto">
          <input
            type="number"
            v-model="inputValue"
            :placeholder="placeholder"
            class="mobile-number mb-3"
          />
          <div class="row">
            <div
              class="col-4 mb-2"
              v-for="(value, index) in keypadValues"
              :key="index"
            >
              <button
                v-if="index == keypadValues.length - 1"
                class="number"
                @click="sliceNumber"
              >
                {{ value.name }}
              </button>
              <button
                v-else-if="value.name != ''"
                @click="onClicknumber(index)"
                class="number"
              >
                {{ value.name }}
              </button>
              <button v-else @click.prevent.stop="clearInput" class="number">
                C
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "Enter Mobile Number"
    }
  },
  data() {
    return {
      inputValue: "",
      keypadValues: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" }
      ]
    };
  },
  methods: {
    sliceNumber() {
      this.inputValue = this.inputValue.slice(0, -1);
    },
    onClicknumber(index) {
      this.inputValue += this.keypadValues[index].name;
    },
    clearInput() {
      this.inputValue = "";
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Partials/PosKeypad.vue